import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import type { Column } from '@tanstack/react-table';

type SortDirection = 'asc' | 'desc' | false;

type TanStackMode<TData> = {
  column: Column<TData, unknown>;
  sortDirection?: never;
  onSort?: never;
};

type StandaloneMode = {
  column?: never;
  sortDirection: SortDirection;
  onSort: () => void;
};

type SortableHeaderProps<TData = unknown> = (TanStackMode<TData> | StandaloneMode) & {
  children: React.ReactNode;
};

export function SortableHeader<TData>({ column, sortDirection, onSort, children }: SortableHeaderProps<TData>) {
  const direction: SortDirection = column ? column.getIsSorted() : sortDirection;
  const handleClick = column ? () => column.toggleSorting() : onSort;

  const Icon = direction === 'asc' ? ArrowUp : direction === 'desc' ? ArrowDown : ArrowUpDown;

  return (
    <button
      type="button"
      className="inline-flex items-center gap-1 cursor-pointer select-none text-xs font-medium text-gray-500 uppercase tracking-wider"
      onClick={handleClick}
      aria-sort={direction === 'asc' ? 'ascending' : direction === 'desc' ? 'descending' : 'none'}
    >
      {children}
      <Icon className={`h-3 w-3 ${direction ? 'text-gray-700' : 'text-gray-400'}`} />
    </button>
  );
}
